<template>
  <div class="flex w-full flex-col justify-center rounded-lg p-16 py-32 text-center">
    <div>
      <DocumentSearchIcon class="text-neutral-95 mx-auto h-14 w-14 stroke-2" />
      <span class="text-neutral-90 mt-2 block text-base font-normal">{{ t("noTemplatesFoundFirst") }}</span>
      <span class="text-neutral-90 mt-1 block text-sm font-normal">{{ t("noTemplatesFoundSecond") }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
//Icons
import { DocumentSearchIcon } from "@heroicons/vue/outline";

//Utils
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<i18n lang="jsonc">
{
  "es": {
    "noTemplatesFoundFirst": "No hemos encontrado plantillas",
    "noTemplatesFoundSecond": "Inténtalo de nuevo modificando el criterio de búsqueda.",
  },
  "pt": {
    "noTemplatesFoundFirst": "Nenhum template encontrado",
    "noTemplatesFoundSecond": "Tente novamente modificando os critérios de pesquisa.",
  },
}
</i18n>
